import useSWRFetcher from "./fetcher";
import settings from "../../../constants/settings";
import { Categories } from "../../../reducers/models/categories";
import useSWRImmutable from "swr/immutable";

export const useCategories = () => {
  const fetcher = useSWRFetcher<Categories>();

  const { data } = useSWRImmutable<Categories, Error>(
    `${settings.api_url}/parts/categories`,
    fetcher,
  );

  return { categories: data?.categories || null };
};
